import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Layout, Col } from "antd";
import { CustomCard, Title } from "../../Utils/UI/Text";
import NewAdministrator from "./NewAdministrator";
import { getAdmin, getAdmins } from "../Application/Administrators.business";
import Searcher from "../UI/Searcher";
import UsersForm from "./Administrator.form";
import Admin from "../Domain/Administrator";

const { Content } = Layout;

export default function Administrator() {
  const { id } = useParams();

  useEffect(() => {
    getAdmins({ filter: { access_level: Admin.ADMIN_ROLES } });
    if (id) {
      getAdmin(id);
    }
  }, [id]);

  return (
    <>
      <Content>
        <Title
          children={"Administradores"}
          childrenTwo={<NewAdministrator />}
        />
        <Searcher userId={id} />
        <Col xs={24} xl={12} span={12}>
        <UsersForm userId={id} />
        </Col>
      </Content>
    </>
  );
}
